module.exports = __webpack_public_path__ + "img/mh.f4841fe9.svg";